// The event types a state machine can listen for: the node catalogue's indicator
// events (DWLF-370) first, then the user's custom events not already listed.
export const mergeEventTypes = (indicatorEventTypes, customEventDefinitions = []) => {
  const customEventTypes = customEventDefinitions.map((e) => e?.eventType || e?.type || e?.eventId).filter(Boolean);
  return [...indicatorEventTypes, ...customEventTypes.filter((t) => !indicatorEventTypes.includes(t))];
};
